<template>
  <transition>
    <div v-if="visible" @click.self="$emit('close')" class="popup-overlay">
      <div
        :class="['popup-form-status-wrapper', success ? 'success' : 'error']"
      >
        <div class="popup-form-status">
          <button
            class="popup-form-status__close btn"
            @click="$emit('close')"
          >
            <Icon icon="form-close" />
          </button>
          <div class="popup-form-status__icon">
            <Icon :icon="success ? 'form-success' : 'form-error'" />
          </div>
          <div class="popup-form-status__title">
            {{ success ? "Спасибо!" : "Ошибка!" }}
          </div>
          <div class="popup-form-status__subtitle">
            {{
              success
                ? "Ваши данные успешно отправлены и мы вам перезвоним чтобы проконсультировать"
                : "Не удалось отправить форму. Пожалуйста, повторите попытку позже."
            }}
          </div>
          <button
            class="popup-form-status__button btn btn-default"
            @click="$emit('close')"
          >
            {{ success ? "Закрыть" : "Повторить" }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    success: {
      type: Boolean,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.popup-overlay {
  position: fixed;
  inset: 0;
  background: #00050980;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 9999;
}
.popup-form-status-wrapper.error {
  .popup-form-status__subtitle {
    max-width: 320px;
  }
}
.popup-form-status-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  z-index: 9999;
  width: 100%;
  max-width: 700px;
  background: #fff;
}
.popup-form-status {
  padding: 70px 20px 44px 20px;
  position: relative;
  color: #545863;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  &__close {
    position: absolute;
    right: 15px;
    top: 15px;
    padding: 0 !important;
    svg {
      width: 40px;
      height: 40px;
      margin: 0;
    }
  }

  &__icon svg {
    width: 55px;
    height: 55px;
    margin: 0;
  }

  &__title {
    font-weight: 500;
    font-size: 46px;
    line-height: 105%;
  }

  &__subtitle {
    font-weight: 500;
    font-size: 16px;
    line-height: 130%;
    opacity: 0.8;
    text-align: center;
  }

  &__button {
    margin-top: 20px;
  }
}

@media (max-width: 767px) {
  .popup-form-status-wrapper {
    max-width: 340px;
  }
  .popup-form-status {
    padding: 50px 20px 20px;
    gap: 10px;
    &__icon svg {
      width: 40px;
      height: 40px;
    }
    &__title {
      font-size: 26px;
      margin-bottom: 5px;
    }
    &__button {
      margin-top: 28px;
    }
    &__close {
      right: 10px;
      top: 10px;
      svg {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
